<app-complex-modal-template
    [canCancel]="true"
    [canConfirm]="createForm.valid && !isSaving()"
    [confirmLabel]="'validate'"
    [title]="(data.pin ? 'pin.editTitle' : 'pin.createTitle') | transloco"
    (onCancelClick)="close()"
    (onClickEvent)="onModalResult($event)">
    <form
        class="mt-7 grid grid-cols-1 items-start gap-x-8 gap-y-4 sm:grid-cols-[minmax(0,1fr)_6rem_minmax(0,1.7fr)]"
        [formGroup]="createForm"
        (submit)="save()">
        <div class="flex flex-col">
            <span class="flex py-4 text-on-surface">{{ 'name' | transloco }}*</span>
            <mat-form-field
                appearance="outline"
                class="w-full"
                subscriptSizing="dynamic">
                <input
                    formControlName="name"
                    matInput
                    maxlength="255"
                    type="text" />
            </mat-form-field>
        </div>
        <div class="flex flex-col">
            <span class="flex py-4 text-on-surface">{{ 'color' | transloco }}</span>
            <app-color-dropdown [colorControl]="createForm.controls.color" />
        </div>
        <div class="flex flex-col">
            <span class="flex py-4 text-on-surface">{{ 'description' | transloco }}</span>
            <mat-form-field
                appearance="outline"
                class="w-full"
                subscriptSizing="dynamic">
                <input
                    formControlName="description"
                    matInput
                    type="text" />
            </mat-form-field>
        </div>
        <label class="col-span-full flex items-center gap-2">
            <input
                class="[font:inherit]"
                formControlName="isShared"
                type="checkbox" />
            {{ 'pin.share' | transloco }}
        </label>
    </form>
</app-complex-modal-template>
